import { useMemo } from 'react';

export enum Background {
  light = '#ffffff',
  dark = '#000000',
}

function useBackgroundColor(color: string | null = null) {
  const [r, g, b] = useMemo(() => {
    if (color === null) return [0, 0, 0];
    const plainHex = color.replace('#', '');
    if (plainHex.length !== 6) return [0, 0, 0];
    const rgb = plainHex.match(/.{1,2}/g);
    return [parseInt(rgb[0], 16), parseInt(rgb[1], 16), parseInt(rgb[2], 16)];
  }, [color]);

  return {
    color: r * 0.299 + g * 0.587 + b * 0.114 > 186 ? Background.dark : Background.light,
  };
}

export default useBackgroundColor;
